var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"footer__content"},[_c('el-row',{attrs:{"gutter":32}},[_c('el-col',{attrs:{"xs":24,"md":16,"lg":12}},[_c('a-footer-address')],1),_c('el-col',{attrs:{"xs":24,"md":8,"lg":12}},[_c('a-footer-navigation')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }